import {FireProjectileAction} from 'src/Action';
import {Game} from '../Game';
import {Loc, Location} from 'src/common/map/Location';
import Connection from 'src/Connection';
import {projectileRenderer} from 'src/Pixi/map/ProjectileRenderer';
import {Projectile} from '../Projectile';

export class FireProjectile {
    public constructor(private game: Game) {
        // Sets instance variables
    }

    public byServer({id, sourceX, sourceY, targetX, targetY}: FireProjectileAction): void {
        const source = new Location(sourceX, sourceY);
        const target = new Location(targetX, targetY);
        const startAt = Date.now();
        const cannon = this.game.map.cannons.find(cannon => source.equals(cannon));
        if (!cannon) return;
        if (!cannon.projectile || cannon.projectile.id !== id) {
            cannon.projectile = {id, startAt, target};
        }
        projectileRenderer.createProjectile(cannon.owner, id, startAt, source, target);
    }

    public byClient(target: Loc): void {
        const owner = this.game.index;
        const {map} = this.game;
        const cannon = map.cannons
            .filter(cannon => map.heldBy[cannon.y][cannon.x] === owner)
            .find(cannon => !cannon.projectile);
        if (!cannon) return;

        const id = Projectile.nextId();
        Connection.send('fire', {id, x: target.x, y: target.y});

        const startAt = Date.now();
        cannon.projectile = {id, startAt, target};
        projectileRenderer.createProjectile(cannon.owner, id, startAt, cannon, target);
    }
}



// WEBPACK FOOTER //
// ./src/game/actions/FireProjectile.ts